/**
 * This function allows for the debouncing of a callback function. It'll run after the delay.
 * This function is useful when you have an event that is called often (eg. keyup) and you don't want to run the callback until a delay in time after the last event.
 * @return [Function] The function that is debounced to only run after `delay`.
 * @link https://youtu.be/cjIswDCKgu0?t=416s
 **/
export function getDebouncedFunction(cb, delay = 1000) {
    let timeout;

    return (...args) => {
        clearTimeout(timeout);
        timeout = setTimeout(()=>{
            cb(...args);
        }, delay);
    }
}